import { FC, ReactNode } from 'react';
import { Sidebar } from './Sidebar';

interface LayoutProps {
  children: ReactNode;
  onBack?: () => void;
}

export const Layout: FC<LayoutProps> = ({ children, onBack }) => {
  return (
    <div className="flex h-screen bg-peach">
      <aside className="w-[300px] h-full bg-white border-r border-peach-1 flex flex-col">
        <Sidebar onBack={onBack} />
      </aside>
      <main className="flex-1 flex flex-col h-full">
        <div className="flex-1 overflow-auto p-4 relative">{children}</div>
      </main>
    </div>
  );
};
